import type { FeatureRequestRow } from "@/infrastructure/supabase/database.types";

// The /feedback source filter (BF-1508): every entry, the ones logged in the app, or one
// Telegram group's. Group values carry a prefix so a group titled "all" or "app" cannot collide.
export const ALL_SOURCES = "all";
export const IN_APP = "app";
export const GROUP_PREFIX = "group:";

type SourceRow = Pick<FeatureRequestRow, "submitted_by" | "submitter_email" | "source_groups">;

/**
 * Whether an entry belongs to the selected source. The Telegram job writes with the service
 * role: no author, and a submitter ending in " (Telegram)". An app entry loses its author too
 * when that user is deleted (0125: on delete set null), so the suffix tells the two apart.
 */
export function matchesSource(r: SourceRow, source: string): boolean {
  if (source === ALL_SOURCES) return true;
  if (source === IN_APP) {
    return r.submitted_by !== null || !(r.submitter_email ?? "").endsWith(" (Telegram)");
  }
  return r.source_groups.includes(source.slice(GROUP_PREFIX.length));
}

/** The selection to apply: a group that no longer exists, or a hidden filter, means all. */
export function effectiveSource(selected: string, groups: string[]): string {
  if (groups.length === 0) return ALL_SOURCES;
  if (selected === IN_APP) return selected;
  if (selected.startsWith(GROUP_PREFIX) && groups.includes(selected.slice(GROUP_PREFIX.length))) {
    return selected;
  }
  return ALL_SOURCES;
}
